<template>
  <div class='deal-calculator'>
    <q-form ref='form'>
      <div class='items'>
        <div class='item' v-for='(item, code) in order.cart.items' :key='code'>
          <div class='name'>{{item.qty}} x {{item.title}}</div>
        </div>
      </div>

      <price :price='order.cart.totalPrice'/>

      <div class='q-my-md'>
        <q-toggle v-model='showCalculator' label='Dealer Net Price + Margin Calculator' :left-label='true'/>

        <q-expansion-item v-model='showCalculator' class='calculator-expand'>
          <div class='calculator-row'>
            <div class='label'>Dealer Net Price</div>
            <div class='value'>
              <price :price='order.cart.price'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <q-input v-model='dealCalculation.grossProfitPercent'
                     label='Gross Profit in %'
                     type='number'
                     hide-bottom-space
                     outlined
                     dense
                     @input='calculate'
                     step='0.01'
            />
          </div>

          <div class='calculator-row'>
            <div class='label'>Price with gross profit</div>
            <div class='value'>
              <price :price='dealCalculation.priceWithGrossProfit'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <q-input v-model='dealCalculation.overtradeAdjustment'
                     label='Overtrade adjustment in $'
                     type='number'
                     hide-bottom-space
                     outlined
                     dense
                     @input='calculate'
                     step='0.01'
            />
          </div>

          <div class='calculator-row'>
            <q-input v-model='dealCalculation.freightCost'
                     label='PD/Freight cost in $'
                     type='number'
                     hide-bottom-space
                     outlined
                     dense
                     @input='calculate'
                     step='0.01'
            />
          </div>

          <div class='calculator-row'>
            <div class='label'>Total</div>
            <div class='value'>
              <price :price='dealCalculation.total'></price>
            </div>
          </div>

          <div class='q-my-md'>
            <q-toggle v-model='dealCalculation.useTrade' label='Use Trade' :left-label='true'/>
          </div>

          <q-expansion-item v-model='dealCalculation.useTrade' class='calculator-expand'>
            <div class='calculator-row'>
              <q-input v-model='dealCalculation.trade.value'
                       label='Trade value in $'
                       type='number'
                       hide-bottom-space
                       outlined
                       dense
                       @input='calculate'
                       step='0.01'
              />
            </div>

            <div class='calculator-row'>
              <q-input v-model='dealCalculation.trade.lessMargin'
                       label='Less margin in $'
                       type='number'
                       hide-bottom-space
                       outlined
                       dense
                       @input='calculate'
                       step='0.01'
              />
            </div>

            <div class='calculator-row'>
              <q-input v-model='dealCalculation.trade.lessWork'
                       label='Work required in $'
                       type='number'
                       hide-bottom-space
                       outlined
                       dense
                       @input='calculate'
                       step='0.01'
              />
            </div>

            <div class='calculator-row'>
              <div class='label'>Final Trade Price</div>
              <div class='value'>
                <price :price='dealCalculation.trade.finalTradePrice'></price>
              </div>
            </div>

            <div class='calculator-row'>
              <div class='label'>Deal Price</div>
              <div class='value'>
                <price :price='dealCalculation.totalWithTrade'></price>
              </div>
            </div>
          </q-expansion-item>
        </q-expansion-item>

        <div class='q-my-md'>
          <q-toggle v-model='dealCalculation.useFinance' label='Use Finance' :left-label='true'/>
        </div>

        <q-expansion-item v-model='dealCalculation.useFinance' class='calculator-expand'>
          <p>
            <strong>Finance Companies T&C may vary from this estimate.</strong>
          </p>

          <div class='calculator-row'>
            <div class='label'>Purchase Price</div>
            <div class='value'>
              <price :price='dealCalculation.totalWithTrade'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <q-input v-model='dealCalculation.finance.depositCash'
                     label='Deposit cash in $'
                     type='number'
                     hide-bottom-space
                     outlined
                     dense
                     @input='calculate'
                     step='0.01'
            />
          </div>

          <div class='calculator-row'>
            <div class='label'>Deposit Trade in $</div>
            <div class='value'>
              <price :price='dealCalculation.finance.depositTrade'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <q-input v-model='dealCalculation.finance.adminFee'
                     label='Admin fee in $'
                     type='number'
                     hide-bottom-space
                     outlined
                     dense
                     @input='calculate'
                     step='0.01'
            />
          </div>

          <div class='calculator-row'>
            <div class='label'>Total Load Required in $</div>
            <div class='value'>
              <price :price='dealCalculation.finance.loanRequirement'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <q-select v-model='dealCalculation.finance.termMonths'
                      label='Term (Months)'
                      behavior='menu'
                      dense
                      outlined
                      @input='calculate'
                      hide-bottom-space
                      :options='[ 12, 24, 36, 48, 60, ]'
            ></q-select>
          </div>

          <div class='calculator-row'>
            <q-input v-model='dealCalculation.finance.dealerBaseRate'
                     label='Dealer base rate, %'
                     type='number'
                     hide-bottom-space
                     outlined
                     dense
                     @input='calculate'
                     step='0.01'
            />
          </div>

          <div class='calculator-row'>
            <q-input v-model='dealCalculation.finance.customerDealRate'
                     label='Customer deal rate, %'
                     type='number'
                     hide-bottom-space
                     outlined
                     dense
                     @input='calculate'
                     step='0.01'
            />
          </div>

          <div class='calculator-row'>
            <div class='label'>Dealer subsidy in $</div>
            <div class='value'>
              <price :price='dealCalculation.finance.dealerSubsidy'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <div class='label'>Monthly repayments in $</div>
            <div class='value'>
              <price :price='dealCalculation.finance.monthlyRepayments'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <div class='label'>Total paid in $</div>
            <div class='value'>
              <price :price='dealCalculation.finance.totalPaid'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <div class='label'>Monthly repayments at base in $</div>
            <div class='value'>
              <price :price='dealCalculation.finance.monthlyRepaymentsAtBase'></price>
            </div>
          </div>

          <div class='calculator-row'>
            <div class='label'>Total paid at base in $</div>
            <div class='value'>
              <price :price='dealCalculation.finance.totalPaidAtBaseRate'></price>
            </div>
          </div>
        </q-expansion-item>
      </div>
    </q-form>
    <q-btn color="primary" label="Save" @click="onOKClick" />
  </div>
</template>

<script>
import Price from './Price.vue';

export default {
  components: { Price },
  props: {
    order: {
      type: Object,
      required: true
    }
  },

  name: 'QuoteCalculator',
  emits: [
    // REQUIRED
    'ok', 'hide'
  ],

  data(){
    return {
      showCalculator: false,
      dealCalculation: {
        "dealerNetPrice": 10250,
        "grossProfitPercent": 0,
        "priceWithGrossProfit": 10250,
        "overtradeAdjustment": 0,
        "freightCost": 0,
        "total": 10250,
        "useTrade": false,
        "trade": {
          "value": 0,
          "lessMargin": 0,
          "lessWork": 0,
          "overtradeAdjustment": 0,
          "finalTradePrice": 0,
        },
        "totalWithTrade": 10250,
        "useFinance": false,
        "finance": {
          purchasePrice: 0,
          depositCash: 0,
          depositTrade: 0,
          loanRequirement: 0,
          adminFee: 0,
          termMonths: 0,
          dealerBaseRate: 0,
          customerDealRate: 0,
          monthlyRepayments: 0,
          totalPaid: 0,
          monthlyRepaymentsAtBase: 0,
          totalPaidAtBaseRate: 0,
          dealerSubsidy: 0,
        }
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.dealCalculation = this.order.quote_calculation
    })
  },
  methods: {
    calculate(){
      this.axiosPost('/quotes/calculate', {
        data: this.dealCalculation
      }, (r) => {
        this.dealCalculation = r.data
      }, false)
    },

    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.$refs.dialog.show()
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide')
    },

    onOKClick () {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok', this.dealCalculation)
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide()
    },

    onCancelClick () {
      // we just need to hide the dialog
      this.hide()
    }
  }
}
</script>
